import { createFileRoute } from '@tanstack/react-router';
import { InstrucoesDeUso } from '@/features/suporte/page/InstrucoesDeUso/InstrucoesDeUso';

export const Route = createFileRoute('/a/suporte/instrucoes-de-uso')({
    component: InstrucoesDeUso,
});
